package tables.organization

import emotion.react.css
import kotlinx.browser.window
import models.OrganizationModel
import org.w3c.fetch.RequestInit
import organisationModelToJsonString
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.p
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface CreateOrgProps : Props {
    var isOpen: Boolean
    var onClose: () -> Unit
    var onUpdate: () -> Unit
}

val CreateOrgModal = FC<CreateOrgProps> { props ->
    if (props.isOpen) {
        var orgName by useState("")
        var orgSite by useState("")
        var orgNote by useState( "")
        var userName by useState("")
        var status by useState("")
        var isactive by useState(false)

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Наименование:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = orgName
                    type = InputType.text
                    onChange = { event ->
                        orgName = event.target.value
                    }
                }
                p {
                    +"Сайт:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = orgSite
                    type = InputType.text
                    onChange = { event ->
                        orgSite = event.target.value
                    }
                }
                p {
                    +"Описание:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = orgNote
                    type = InputType.text
                    onChange = { event ->
                        orgNote = event.target.value
                    }
                }
                p {
                    +"Пользотель:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = userName
                    type = InputType.text
                    onChange = { event ->
                        userName = event.target.value
                    }
                }
                p {
                    +"Активная:"
                }
                div {
                    input {
                        type = InputType.checkbox
                        checked = isactive
                        onChange = {
                            isactive = it.target.checked
                        }
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        disabled = (orgName.length < 3) || (orgSite.length < 5)
                        +"Сохранить"
                        val orgModel = OrganizationModel(0, orgName, orgSite, orgNote, userName, isactive)
                        onClick = {
                            window.fetch(
                                urlAddress + "api/organization", RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = organisationModelToJsonString(orgModel)
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        response.text().then {
                                            status = it
                                        }
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

